import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import AssetTypeService from '/@/modules/asset/services/AssetTypeService';
import { AssetType } from '@/modules/asset/enums/AssetType';

export class AssetStatus extends Enum {
  key!: string;
  value!: string;
  descriptionValue!: string;
  title?: string;
  subtitle?: string;
  descriptions?: string[];
  assets?: AssetType[];
  color!: string;
  backgroundColor!: string;

  static PENDING: AssetStatus = {
    key: 'pending',
    get value() {
      return Lang.t('asset.pending');
    },
    get descriptionValue() {
      return Lang.t('asset.pending');
    },
    color: '#7E84A3',
    backgroundColor: '#7E84A31A'
  };

  static LIQUIDATED: AssetStatus = {
    key: 'liquidated',
    get value() {
      return Lang.t('asset.liquidated');
    },
    get descriptionValue() {
      return Lang.t('asset.liquidate');
    },
    get title() {
      return Lang.t('asset.how-an-asset');
    },
    get descriptions() {
      return AssetStatus.getLiquidateDescriptions();
    },
    assets: AssetTypeService.getCanBeLiquidated(),
    color: '#1D9868',
    backgroundColor: '#1D98681A'
  };

  static DISTRIBUTED: AssetStatus = {
    key: 'distributed',
    get value() {
      return Lang.t('asset.distributed');
    },
    get descriptionValue() {
      return Lang.t('asset.distribute');
    },
    get title() {
      return Lang.t('asset.how-distribute-asset');
    },
    get descriptions() {
      return AssetStatus.getDistributeDescriptions();
    },
    assets: AssetTypeService.getCanBeDistributed(),
    color: '#19AEDD',
    backgroundColor: '#E8F7FC'
  };

  /**
   * @deprecated
   * Deprecated with the removal of Income type assets
   */
  static RECEIVED: AssetStatus = {
    key: 'received',
    get value() {
      return Lang.t('asset.received');
    },
    get descriptionValue() {
      return Lang.t('asset.received');
    },
    color: '#48BEEA',
    backgroundColor: '#48BEEA1A'
  };

  static DISCARDED: AssetStatus = {
    key: 'discarded',
    get value() {
      return Lang.t('asset.discarded');
    },
    get descriptionValue() {
      return Lang.t('asset.discard');
    },
    get title() {
      return Lang.t('asset.how-discard-an');
    },
    get subtitle() {
      return Lang.t('asset.if-is-may');
    },
    get descriptions() {
      return AssetStatus.getDiscardDescriptions();
    },
    assets: AssetTypeService.getCanBeDiscarded(),
    color: '#F97068',
    backgroundColor: '#F970681A'
  };

  static getLiquidateDescriptions(): string[] {
    return [
      Lang.t('asset.determine-professional-involved'),
      Lang.t('asset.obtain-never-the'),
      Lang.t('asset.maintain-relating-estate'),
      Lang.t('asset.if-item-is')
    ];
  }

  static getDistributeDescriptions(): string[] {
    return [
      Lang.t('asset.appraise-value-appropriately'),
      Lang.t('asset.verify-recipients-accept'),
      Lang.t('asset.ensure-paperwork'),
      Lang.t('asset.ensure-release'),
      Lang.t('asset.double-check-laws'),
      Lang.t('asset.document-distribution')
    ];
  }

  static getDiscardDescriptions(): string[] {
    return [
      Lang.t('asset.executors-communicate-assets'),
      Lang.t('asset.executors-and-were'),
      Lang.t('asset.the-of-discarded'),
      Lang.t('asset.executors-all-concerning')
    ];
  }

  static getAssetStatusesInformation(): AssetStatus[] {
    return [AssetStatus.LIQUIDATED, AssetStatus.DISTRIBUTED, AssetStatus.DISCARDED];
  }
}
